import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { HotlineLpView } from '@/feature/hotline/lp/page/HotlineLpView';
import { getConsultationLink } from '@/feature/hotline/lp/util/link';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { isGuest } from '@/utils/resources/auth/authResource';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名コンサルホットラインのLP（ロジック部分のみ）
 */
export const HotlineLpPage = () => {
    const auth = useTypeSelector((rootState) => rootState.auth);
    /** ゲストユーザーか */
    const isGuestUser = isGuest(auth);
    /** 相談するリンク */
    const consultationLink = getConsultationLink(auth);
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { description: META_DESCRIPTION.hotline.lp(), relativePath: pagePath.hotline.lp(), title: '匿名コンサルホットライン' }), _jsx(HotlineLpView, { consultationLink: consultationLink, isGuest: isGuestUser })] }));
};
